import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { CashDeskService } from "../../../../services/cash-desk.service";
import { CashDeskCloseControlService } from "../../../../services/cash-desk-close-control/cash-desk-close-control.service";

@Component({
  selector: "cash-desk-close-export-dialog",
  templateUrl: "cash-desk-close-export-dialog.component.html",
})
export class CashDeskCloseExportDialogComponent implements OnInit {
  form: FormGroup;
  loading: boolean;

  constructor(
    public dialogRef: MatDialogRef<CashDeskCloseExportDialogComponent>,
    private formBuilder: FormBuilder,
    private cashDeskCloseControlService: CashDeskCloseControlService,
    private notificationToastService: NotificationToastService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.formBuilder.group({
      from: ["", Validators.required],
      to: ["", Validators.required],
    });
  }

  async ngOnInit() {
    await this.chargeFromDate();
  }

  private async chargeFromDate() {
    try {
      this.loading = true;
      let from = await this.cashDeskCloseControlService.getFromExport();
      from = from ? from : new Date();
      this.form.patchValue({ from, to: null });
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Exportación ERP"
      );
    } finally {
      this.loading = false;
    }
  }

  get f() {
    return this.form.controls;
  }

  async onNoClick() {
    this.dialogRef.close(false);
  }

  async export() {
    try {
      if (this.form.valid) {
        this.loading = true;
        const result = await this.cashDeskCloseControlService.export(
          this.f.from.value,
          this.f.to.value
        );
        this.notificationToastService.success(
          "Se exportaron " + result + "facturas",
          "Exportación ERP"
        );
        await this.chargeFromDate();
      }
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Exportación ERP"
      );
    } finally {
      this.loading = false;
    }
  }
}
